import { defineMessages } from "react-intl";
const messages = defineMessages({
    addCustomTitle: {
        id: "app.amenity.selector.defaults.options.custom",
        defaultMessage: "Custom",
    },
    airConditioning: {
        id: "app.amenity.selector.defaults.options.air.conditioning",
        defaultMessage: "Air Conditioning",
    },
    balcony: {
        id: "app.amenity.selector.defaults.options.balcony",
        defaultMessage: "Balcony",
    },
    dishwasher: {
        id: "app.amenity.selector.defaults.options.dishwasher",
        defaultMessage: "Dishwasher",
    },
    furnished: {
        id: "app.amenity.selector.defaults.options.furnished",
        defaultMessage: "Furnished",
    },
    parking: {
        id: "app.amenity.selector.defaults.options.parking",
        defaultMessage: "Parking",
    },
    outdoor: {
        id: "app.amenity.selector.defaults.options.outdoor",
        defaultMessage: "Outdoor Space",
    },
    storage: {
        id: "app.amenity.selector.defaults.options.storage",
        defaultMessage: "Storage Space",
    },
});
export default messages;
